import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useDisabledFields } from 'components/modules/Insurance/hooks/useDisabledFields';
import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';
import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as InsuranceActions from 'store/insurance/actions';
import * as InsuranceConstants from 'store/insurance/constants';
import * as InsuranceSelectors from 'store/insurance/selectors';

import { TYPES } from './VinOrBodyNumberInput.constants';

const { ROUTES } = Insurance;

export const useVinOrBodyNumberInputPresenter = ({ labels, masks }) => {
  const dispatch = useDispatch();

  const errors = useSelector(CarInstanceSelectors.selectErrors);
  const stageStatus = useSelector(
    InsuranceSelectors.selectStageLoading(InsuranceConstants.STAGES_FIELDS.VIN_RECOGNITION)
  );
  const {
    [CarInstanceConstants.VALUE_FIELDS.BODY_NUMBER]: bodyNumber,
    [CarInstanceConstants.VALUE_FIELDS.STEERING_WHEEL]: steeringWheel,
    [CarInstanceConstants.VALUE_FIELDS.VIN]: vin,
  } = useSelector(CarInstanceSelectors.selectValues);

  const isRightSteeringWheel = steeringWheel === CarInstanceConstants.STEERING_WHEEL_VALUES.RIGHT;
  const type = isRightSteeringWheel ? TYPES.BODY : TYPES.VIN;
  const value = isRightSteeringWheel ? bodyNumber : vin;
  const error =
    errors[
      isRightSteeringWheel
        ? CarInstanceConstants.VALUE_FIELDS.BODY_NUMBER
        : CarInstanceConstants.VALUE_FIELDS.VIN
    ];

  const { route } = useRouteMatch({ routes: ROUTES }) ?? {};
  const { disabled } = useDisabledFields({ page: route });

  const onChange = useCallback(
    (value) => {
      const field = isRightSteeringWheel
        ? CarInstanceConstants.VALUE_FIELDS.BODY_NUMBER
        : CarInstanceConstants.VALUE_FIELDS.VIN;

      dispatch(CarInstanceActions.setCarInstance({ [field]: (value || '').toUpperCase() }));
      dispatch(CarInstanceActions.updateErrors({ [field]: '' }));
    },
    [isRightSteeringWheel]
  );
  const onVinRecognition = useCallback(() => {
    if (type !== TYPES.VIN) {
      return;
    }

    dispatch(InsuranceActions.vinRecognition());
  }, [type]);

  useEffect(() => {
    let payload = CarInstanceActions.setCarInstance({
      [CarInstanceConstants.VALUE_FIELDS.BODY_NUMBER]: undefined,
    });

    if (isRightSteeringWheel) {
      payload = CarInstanceActions.setCarInstance({
        [CarInstanceConstants.VALUE_FIELDS.VIN]: undefined,
      });
    }

    dispatch(payload);
  }, [isRightSteeringWheel]);

  return {
    disabled,
    error,
    label: labels[type],
    loading: stageStatus === InsuranceConstants.STAGES_LOADING_VALUES.LOADING,
    mask: masks[type],
    onChange,
    onVinRecognition,
    type,
    value: (value || '').toUpperCase(),
  };
};
